import request from '@/utils/request'
import { getToken } from '@/utils/auth'

const BASE_API_PREFIX = process.env.VUE_APP_BASIC_DATA_API
const BASE_API_PREFIX_C = process.env.VUE_APP_BASIC_DATA_API_C

/**
 * 通过VIN查询未绑定ICCID集合
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/8244
 */
export const getIccidListByVin = (data, options = {}) => {
  return request({
    url: `${BASE_API_PREFIX}newVinCard/queryUnBindCardByVin`,
    data,
    ...options
  })
}

/**
 * 通过VIN查询已经绑定的ICCID集合
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/8244
 */
export const getBindIccidListByVin = (data, options = {}) => {
  return request({
    url: `${BASE_API_PREFIX}newVinCard/queryBindCardByVin`,
    data,
    ...options
  })
}

/**
 * 短信发送
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/5136
 */
export const sendSms = data => {
  return request({
    url: `${BASE_API_PREFIX}sms/sendSmsRnr`,
    data
  })
}

/**
 * 文件上传
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/7156
 */
export const cuscImageUpload = data => {
  // 表单数据
  const form = new FormData()
  // 遍历数据
  Object.keys(data).forEach(key => {
    form.append(key, data[key])
  })
  return request({
    url: `${BASE_API_PREFIX}cuscImage/upload`,
    headers: {
      'Content-Type': 'multipart/form-data;',
      'Authorization': `bearer ${getToken()}`
    },
    data: form
  })
}

/**
 * 文件上传
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/7156
 */
export const fileUpload = data => {
  // 表单数据
  const form = new FormData()
  // 遍历数据
  Object.keys(data).forEach(key => {
    form.append(key, data[key])
  })
  return request({
    url: `${BASE_API_PREFIX}file/upload`,
    headers: {
      'Content-Type': 'multipart/form-data;',
      'Authorization': `bearer ${getToken()}`
    },
    data: form
  })
}

/**
 * 校验输入的vin号和iccid是否合法
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/5116
 */
export const verifyVinCards = data => {
  return request({
    url: `${BASE_API_PREFIX}newVinCard/checkVinCard`,
    data
  })
}

/**
 * 检查vin(企业实名H5)
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/11016
 */
export const checkVin = data => {
  return request({
    url: `${BASE_API_PREFIX}newVinCard/checkVin`,
    data
  })
}

/**
* 校验用户提交的身份信息与身份证是否匹配
*/
export function checkPersonInfoWithOcr(data) {
  return request({
    url: `${BASE_API_PREFIX}personalRnr/checkPersonOcr`,
    data,
    method: 'POST'
  })
}

/**
 * 提交自然人实名认证
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/8608
 */
export const submitRnr = data => {
  return request({
    url: `${BASE_API_PREFIX}personalRnr/h5/submitRnr`,
    data
  })
}

/**
* 校验用户提交的身份信息与身份证是否匹配
*/
export function checkPersonInfoWithOcrForEnterprise(data) {
  return request({
    url: `${BASE_API_PREFIX}enterpriseRnr/h5/checkPersonOcr`,
    data,
    method: 'POST'
  })
}

/**
 * 企业实名H5提交
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/10984
 */
export const submitEnterpriseRnr = data => {
  return request({
    url: `${BASE_API_PREFIX}enterpriseRnr/h5/submitRnr`,
    data
  })
}

/**
 * 活体检测结果回调
 * @yapi http://10.166.2.23:3000/project/28/interface/api/8604
 */
export const livenessCallback = data => {
  return request({
    url: `${BASE_API_PREFIX}personalRnr/h5/livenessCallback`,
    data
  })
}

/**
 * 企业实名H5活体回调
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/10988
 */
export const enterpriseLivenessCallback = data => {
  return request({
    url: `${BASE_API_PREFIX}enterpriseRnr/h5/livenessCallback`,
    data
  })
}

/**
 * 查询协议
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/10172
 */
export const queryPotocolManage = (data) => {
  return request({
    url: `${BASE_API_PREFIX}protocolManage/query`,
    data
  })
}

/**
 * 查询协议
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/10172
 */
export const queryPotocolCustomerManage = (data) => {
  return request({
    url: `${BASE_API_PREFIX_C}protocolManage/customer/query`,
    data
  })
}

/**
 * 车企端ocr识别
 */
export const ocrIdcardInEnterprise = data => {
  return request({
    url: `${BASE_API_PREFIX}ocr/idCard`,
    data
  })
}

// 获取角色信息
export function getRoleMessage() {
  return request({
    url: `${BASE_API_PREFIX}userEnterprise/auth/queryCurrentRoleCode`,
    method: 'get'
  })
}

// 保存扫描获得的二维码内容信息
export function saveScanedVinDetail(vinDetailJson) {
  return request({
    url: `${BASE_API_PREFIX}newVinCard/vinInfoSave`,
    data: vinDetailJson
  })
}



// WEBPACK FOOTER //
// ./src/api/rnr.js